(function ($) {
    jQuery.widget('nsp.menuMobile', {
        options: {},
        _setOption: function (key, value) {
            this.options[key] = value
            this._update()
        },
        _create: function () {
            const self = this

            self.elem = self.element

            self._iniVars()        

            self._toggleSubmenu()
        
            self._toggleFirstLvlMenu()

            self._toggleSecondLvlMenu()

            $(window).on('resize', function () {
                if (api.winW >= 768) {
                    self._closeSubmenu();
                    self.rootItems.removeClass('is-open')
                    $('nav > ul > li > a > span').removeClass('is-open')
                }
            })
        },

        _iniVars: function () {
            const self = this

            self.rootItems = $('nav > ul > li > a', self.element)
            self.lnks = $('.header-mob__lnkIcon', self.element)           
        },

        _toggleFirstLvlMenu:function(){
            const self = this
            
            self.lnks.click(function (e) {
                e.preventDefault()
                e.stopPropagation()                 

                if($(this).hasClass('mob-top')){

                    var others = $('.mob-top').not(this)                   

                    others.removeClass('is-open')

                    others.each((idx, other) => {
                        var sibling = $(other).next();
                        sibling.slideUp() 
                    })
                }
        
            })
        },

        _toggleSecondLvlMenu:function(){
            const self = this

            self.lnks.click(function (e) {
                e.preventDefault()
                e.stopPropagation()                  

                if($(this).hasClass('mob-sec')){

                    var others = $('.mob-sec').not(this)                   

                    others.removeClass('is-open')

                    others.each((idx, other) => {
                        var sibling = $(other).next();
                        sibling.slideUp() 
                       
                    })
                }               
      
            })
        },

        _toggleSubmenu: function () {
            const self = this

            self.lnks.click(function (e) {
                e.preventDefault()
                e.stopPropagation()        
                
              

                if (!$(this).hasClass('is-open')) {
                    self._closeSubmenu()
                }


                $(this).toggleClass('is-open')

                // if($(this).hasClass('mob-top')){

                //     var others = $('.mob-top').not(this)                   

                //     others.removeClass('is-open')

                //     others.each((idx, other) => {
                //         var sibling = $(other).next();
                //         sibling.slideUp() 

                        
                //     })



                // }


                if($(this).hasClass('header-mob__sub-first')){
                    var others = $('.header-mob__sub-first').not(this)                   

                    others.removeClass('is-open')

                    others.each((idx, other) => {
                        var sibling = $(other).next();
                        sibling.slideUp() 
                       
                    })
                }
               


               

              //  self.lnks.removeClass('is-open')

               
              
                var sibling = $(this).next();
                sibling.slideToggle()      

                self.elem.find('.header-mob__menu__submenu').toggleClass('close')        
            })
        },

        _closeSubmenu: function () {
            const self = this

            $('.header-mob__menu ul > li > a ').each(function () {             
                $('.header-mob__sub-sec').slideUp()
                $('.header-mob__menu__sub li a').removeClass('is-open')                
            })
        }        
    })
})(jQuery);
